import React, { useEffect, useState } from 'react';
import {
  Menu,
  ListItemIcon,
  Checkbox,
  ListItemText,
  InputAdornment,
  TextField,
  MenuItem,
} from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';

export const CustomMenuSelect = ({
  anchorEl,
  isOpen,
  options,
  className,
  handleClose,
  handleValue,
  isShowAll,
  handleResetList,
  isShowAllSearch,
  subMenuPositionOverride,
}) => {
  const [menuList, setMenuList] = useState([]);
  const [activityTypeSearch, setActivityTypeSearch] = useState('');
  const [isAllSelect, setIsAllSelect] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    const initialMenuList =
      options?.map((option) => ({
        ...option,
        isChecked: option?.isChecked || false,
      })) || [];
    const search = activityTypeSearch?.trim()?.toLowerCase();
    const maybeFiltered = search
      ? initialMenuList?.filter((i) => i?.name?.toLowerCase()?.includes(search))
      : initialMenuList;
    setMenuList(maybeFiltered);
    setSelectedItems(initialMenuList?.filter((option) => option?.isChecked));
  }, [options]);

  useEffect(() => {
    const isAllSelected = menuList?.every((menuItem) => menuItem?.isChecked);
    setIsAllSelect(isAllSelected);
  }, [menuList]);

  const handleSelected = (event, selectedItemsParam) => {
    const newMenuList = options?.map((menuItem) => ({
      ...menuItem,
      isChecked: selectedItemsParam?.some((selected) => selected?.id === menuItem?.id),
    }));
    const isAllSelectNow = options?.every((option) =>
      selectedItemsParam?.some((selected) => selected?.id === option?.id),
    );
    setIsAllSelect(isAllSelectNow);
    const search = activityTypeSearch?.trim()?.toLowerCase();
    setMenuList(
      search ? newMenuList?.filter((i) => i?.name?.toLowerCase()?.includes(search)) : newMenuList,
    );
    setSelectedItems(selectedItemsParam);
    const updatedOptions = options?.map((option) => ({
      ...option,
      isChecked: selectedItemsParam?.some((selected) => selected?.id === option?.id),
    }));
    handleValue(updatedOptions);
  };

  const handleAllSelected = (isChecked) => {
    const result = options?.map((menu) => ({
      ...menu,
      isChecked: isChecked,
    }));

    setIsAllSelect(isChecked);
    const search = activityTypeSearch?.trim().toLowerCase();
    setMenuList(search ? result.filter((i) => i?.name?.toLowerCase()?.includes(search)) : result);
    setSelectedItems(isChecked ? [...options] : []);
    handleValue(result);
  };

  const handleSearch = (event) => {
    const value = event?.target?.value;
    setActivityTypeSearch(value);

    if (value?.trim()) {
      setMenuList(
        options
          ?.filter((item) => item?.name?.toLowerCase()?.includes(value?.toLowerCase()))
          ?.map((item) => ({
            ...item,
            isChecked: selectedItems?.some((selected) => selected?.id === item?.id),
          })),
      );
    } else {
      setMenuList(
        options?.map((item) => ({
          ...item,
          isChecked: selectedItems?.some((selected) => selected?.id === item?.id),
        })),
      );
    }
  };

  const displayList = activityTypeSearch?.trim() ? menuList : options;

  const handleMenuClose = () => {
    setActivityTypeSearch('');
    setMenuList(
      options?.map((item) => ({
        ...item,
        isChecked: selectedItems?.some((selected) => selected?.id === item?.id),
      })),
    );
    handleClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open={isOpen}
      className={className}
      onClose={handleMenuClose}
      anchorOrigin={
        subMenuPositionOverride?.anchorOrigin || { vertical: 'top', horizontal: 'right' }
      }
      transformOrigin={
        subMenuPositionOverride?.transformOrigin || { vertical: 'top', horizontal: 'left' }
      }
    >
      {isShowAllSearch && (
        <MenuItem className='custom-multi-select-list pe-4'>
          <TextField
            value={activityTypeSearch}
            autoFocus
            fullWidth
            placeholder={'Search Tags'}
            onChange={handleSearch}
            className='custom-search-input'
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          />
        </MenuItem>
      )}
      {isShowAll && !activityTypeSearch.trim() && (
        <MenuItem
          className='custom-multi-select-list pe-4'
          onClick={() => {
            handleAllSelected(!isAllSelect);
          }}
        >
          <ListItemIcon>
            <Checkbox color='primary' checked={isAllSelect} />
          </ListItemIcon>
          <ListItemText primary={'All'} />
        </MenuItem>
      )}
      {displayList?.map((menuItem) => {
        return (
          <MenuItem
            className='custom-multi-select-list pe-4'
            key={menuItem.id}
            value={menuItem.id}
            onClick={() => {
              handleSelected(
                null,
                menuItem.isChecked
                  ? selectedItems?.filter((item) => item?.id !== menuItem?.id)
                  : [...selectedItems, menuItem],
              );
            }}
          >
            <ListItemIcon>
              <Checkbox color='primary' checked={menuItem?.isChecked || isAllSelect} />
            </ListItemIcon>
            <ListItemText primary={menuItem?.name} />
          </MenuItem>
        );
      })}
    </Menu>
  );
};
